/* eslint-disable */
// import { TweenLite, TimelineLite, Power0, Power3 } from 'gsap'
// import { TweenLite } from 'gsap'
import TimelineMax from 'gsap/TimelineMax'
import ProductListed from '../components/ProductListed'
import FiltersNav from '../components/FiltersNav'
// import SubcategoryTitle from '../components/SubcategoryTitle'

const Isotope = require('isotope-layout')

// Declare variables here so that they are shared between the routers functions
let isotope

export default {
  init () {
    // The products master timeline, to be used for true stagger animation
    const pmtl = new TimelineMax({ autoRemoveChildren: true })
    pmtl.data = { stagger: 0.025 }

    // Hover Effects
    $('body').on('mouseenter', '.product-listed', function (event) {
      // if (typeof $(this).data('animateInDone') === 'undefined' || $(this).data('animateInDone') !== true) {
      //   return
      // }

      if (window.isTouch) {
        return
      }
      $(this).data('timelineHover').play()
    })

    $('body').on('mouseleave', '.product-listed', function (event) {
      if (window.isTouch) {
        return
      }
      $(this).data('timelineHover').reverse()
    })

    const scrollTop = $(window).scrollTop()

    // Isotope filtering
    isotope = new Isotope('.product-list', {
      itemSelector: '.product-listed',
      layoutMode: 'fitRows',
      transitionDuration: 0,
    })

    $(window).scrollTop(scrollTop) // That's ugly but in FF isotope was causing the page to scroll to top after navigating to a product list through the back button.

    // eslint-disable-next-line no-unused-vars
    const filtersNav = new FiltersNav($('.filters-nav'), isotope)

    // init Isotope with hash filter
    filtersNav.onHashChange(true)

    // set initial checkboxes from hash
    const hashFilter = filtersNav.getHashFilter()
    if (hashFilter) {
      const filters = hashFilter.split(',')
      filters.forEach((filter) => {
        const $checkbox = filtersNav.$checkboxes.filter(`[value="${filter}"]`)
        $checkbox.prop('checked', 'checked')
      })
    }

    const checkForClicksOutsideFiltersNav = (event) => {
      const $target = $(event.target)
      if ($target !== filtersNav.$el && $target.closest(filtersNav.$el).length === 0) {
        filtersNav.toggle()
        $('body').off('click', checkForClicksOutsideFiltersNav)
      }
    }

    $('.filters-nav-toggle').click(function (event) {
      $('body').off('click', checkForClicksOutsideFiltersNav)
      event.preventDefault()
      filtersNav.toggle()

      if (filtersNav.isOpen) {
        setTimeout(() => {
          $('body').on('click', checkForClicksOutsideFiltersNav)
        }, 100)
      }
    })

    $('.product-listed').each((i, el) => new ProductListed($(el), pmtl))
  },

  finalize () {
  },

  destroy () {
    if (isotope && typeof isotope.destroy === 'function') {
      isotope.destroy()
      isotope = null
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/routes/productsListPage.js